import React from "react";
import RecommendContentArea from "../../common/recommend-content/RecommendContentArea";
import RecommendContent from "../../common/RecommendContent";
import { SwiperSlide } from "swiper/react";
import { useGetOtherProjects } from "../../utils/useProject";

type Props = {
  emitId: string;
};
const OtherProjectsContainer: React.FC<Props> = ({ emitId }) => {
  const { projects } = useGetOtherProjects({ emit_id: emitId });

  return (
    <>
      {projects?.length ? (
        <RecommendContentArea
          title="終了日が近いプロジェクト"
          subTitle=""
          linkTo={{ pathname: "project/list", search: "?sort=end_date" }}
          swiperSlides={
            <>
              {projects.map((p) => (
                <SwiperSlide key={p.id}>
                  <RecommendContent
                    id={p.id}
                    name={p.name}
                    start_date={p.start_date}
                    type={"project"}
                    trackingLabel="EndingSoonProject"
                    imgs={p.imgs}
                  />
                </SwiperSlide>
              ))}
            </>
          }
        />
      ) : null}
    </>
  );
};

export default OtherProjectsContainer;
